import { useContextFallback } from '@prenuvo/halo';

import { CarePlanServiceContext } from './care-plan-service.context';

export const useCarePlanService = () => useContextFallback(CarePlanServiceContext);
